




































































import Vue, { PropType } from 'vue';
import WidgetWrapper from '@/components/widgets/WidgetWrapper.vue';
import FieldSelect from '@/components/form/FieldSelect.vue';
import FieldInput from '@/components/form/FieldInput.vue';
import { DropdownList, ECappingType, EDurationType } from '@/types';
import { FrequencyCappingData } from '@/types/campaign/targets';
import { getTranslate } from '@/helpers/translateHelpers';

export default Vue.extend({
  name: 'TheFrequencyCapping',
  components: { WidgetWrapper, FieldSelect, FieldInput },
  props: {
    data: {
      type: Object as PropType<FrequencyCappingData>,
      required: true,
    },
  },

  watch: {
    data(newValue) {
      this.campaign = newValue;
    },
  },

  computed: {
    cappingTypes(): Array<DropdownList> {
      return [
        {
          label: getTranslate(
            'pages.campaignForm.tabs.targets.blocks.frequencyCapping.perImpressions'
          ),
          value: ECappingType.IMPRESSIONS,
        },
        {
          label: getTranslate(
            'pages.campaignForm.tabs.targets.blocks.frequencyCapping.perClicks'
          ),
          value: ECappingType.CLICKS,
        },
      ];
    },
    cappingValueText(): string {
      switch (this.campaign.capping_type) {
        case ECappingType.IMPRESSIONS:
          return getTranslate(
            'pages.campaignForm.tabs.targets.blocks.frequencyCapping.labelImpression'
          );
        case ECappingType.CLICKS:
          return getTranslate(
            'pages.campaignForm.tabs.targets.blocks.frequencyCapping.labelClicks'
          );
        default:
          return '';
      }
    },
    durationTypes(): Array<DropdownList> {
      return [
        {
          label: getTranslate(
            'pages.campaignForm.tabs.targets.blocks.frequencyCapping.perDay'
          ),
          value: EDurationType.DAY,
        },
        {
          label: getTranslate(
            'pages.campaignForm.tabs.targets.blocks.frequencyCapping.perHours'
          ),
          value: EDurationType.HOUR,
        },
        {
          label: getTranslate(
            'pages.campaignForm.tabs.targets.blocks.frequencyCapping.perCampaign'
          ),
          value: EDurationType.CAMPAIGN,
        },
      ];
    },
    durationValueText(): string {
      switch (this.campaign.duration_type) {
        case EDurationType.DAY:
          return getTranslate(
            'pages.campaignForm.tabs.targets.blocks.frequencyCapping.labelDays'
          );
        case EDurationType.HOUR:
          return getTranslate(
            'pages.campaignForm.tabs.targets.blocks.frequencyCapping.labelHours'
          );
        default:
          return '';
      }
    },
  },

  methods: {
    change(name, value) {
      this.$emit('changeCampaign', name, value);
    },
    changeChecked(checked) {
      this.change('is_frequency_capping', checked);
    },
  },

  data() {
    return {
      campaign: this.data,
    };
  },
});
